// extracted by mini-css-extract-plugin
export default {"button":"ForgetPassword_button__fZLvZ"};